import React, { useCallback, useEffect, useState } from "react";
import TableEmpresasContador from "../../organisms/contadoresEmpresas/TableEmpresasContador";
import { GET_ENTERPRISE_BY_ACCOUNTANT } from "../../../api/apiEmpresas";
import { useParams } from "react-router-dom";
import SubHeading from "../../atoms/SubHeading";
import { GET_ACCOUNTANT_BY_ID } from "../../../api/apiAdmin";
import { GET_POLLS_BY_ACCOUNTANT } from "../../../api/apiPoll";
import EstadisticasContador from "../../organisms/contadoresEmpresas/EstadisticasContador";
import { PropagateLoader } from "react-spinners";
import { decryptId } from "../../../functions/idEncryptor";
import CardHeader from "../../atoms/CardHeader";
import Breadcrumb from "../../molecules/Breadcrumb";
import Fuse from "fuse.js";

const EmpresasContadorAdminTemplate = ({ user }) => {
	const [empresas, setEmpresas] = useState();
	const [filteredEmpresas, setFilteredEmpresas] = useState([]);
	const [encuestas, setEncuestas] = useState();
	const [contador, setContador] = useState();
	const [loading, setLoading] = useState(false);
	const [filters, setFilters] = useState({ empresa: "", rfc: "" });
	const { id } = useParams();

	const getEnterprises = useCallback(async () => {
		try {
			setLoading(true);
			const enterpriseData = await GET_ENTERPRISE_BY_ACCOUNTANT(decryptId(id));
			const sortedData = enterpriseData.sort((a, b) => a.id - b.id);
			setEmpresas(sortedData);
			setFilteredEmpresas(sortedData);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}, [id]);

	const getPolls = useCallback(async () => {
		try {
			setLoading(true);
			const pollsData = await GET_POLLS_BY_ACCOUNTANT(decryptId(id));
			setEncuestas(pollsData);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}, [id]);

	const getAccountant = useCallback( async () => {
		try {
			setLoading(true);
			const accountantData = await GET_ACCOUNTANT_BY_ID(decryptId(id));
			setContador(accountantData);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	}, [id]);

	useEffect(() => {
		getEnterprises();
		getAccountant();
		getPolls();
	}, [id, getEnterprises, getAccountant, getPolls]);

	useEffect(() => {
		if (!empresas) return;

		const fuse = new Fuse(empresas, {
			keys: [
				{ name: "name", weight: 0.5 },
				{ name: "rfc", weight: 0.3 },
			],
			threshold: 0.3,
		});

		const searchTerms = `${filters.empresa} ${filters.rfc}`.trim();

		if (searchTerms) {
			const results = fuse.search(searchTerms).map(result => result.item);
			setFilteredEmpresas(results);
		} else {
			setFilteredEmpresas(empresas);
		}
	}, [filters, empresas]);

	return (
		<div className="space-y-2">
            <CardHeader>
				<Breadcrumb
                    items={[
                        { label: "Usuarios", to: "/usuarios" },
                        { label: "Contadores", to: "/contadores" },
                        { label: `${contador ? contador?.name : "cargando..."}`, to: null },
                    ]}
                />
                <div className="w-full flex flex-col md:flex-row justify-between px-4">
                        <SubHeading text={`Empresas: ${empresas ? empresas?.length : 0}`} color="blue" />
                        <SubHeading text={contador ? contador?.user?.email : "cargando..."} color="blue" />
                        <SubHeading text={contador ? contador?.cellphone : "cargando..."} color="blue" />
                </div>
            </CardHeader>
			<TableEmpresasContador data={filteredEmpresas} loading={loading} filters={filters} setFilters={setFilters} />
			{ user?.roleInfo?.isSuperAdmin === true &&
				(loading === true ?
				<div className="h-full w-full flex items-center justify-center">
					<PropagateLoader color="red" />
				</div>
				:
					<EstadisticasContador data={encuestas || []} />
				)
			}
		</div>
	);
};

export default EmpresasContadorAdminTemplate;
